import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AllocationModule} from 'src/app/ui/webapp/component/allocation/allocation.module';
import {WebappComponentModule} from 'src/app/ui/webapp/component/webapp-component.module';
import {SharedComponentModule} from 'src/app/ui/shared/component/shared-component.module';
import {DomainModule} from 'src/app/domain/domain.module';
import {InfrastructureModule} from 'src/app/infrastructure/infrastructure.module';
import {IonicModule} from '@ionic/angular';
import {OnboardingAllocationDetailsPage} from 'src/app/ui/webapp/page/onboarding/editable-summary/portfolio/allocation/details/oboarding-allocation-details-page.component';
import {OnboardingEditableSummaryAllocationPage} from 'src/app/ui/webapp/page/onboarding/editable-summary/portfolio/allocation/onboarding-editable-summary-allocation.page';
import {OnboardingEditableSummaryAllocationRouting} from 'src/app/ui/webapp/page/onboarding/editable-summary/portfolio/allocation/onboarding-editable-summary-allocation.routing';

@NgModule({
  imports: [
    CommonModule,
    AllocationModule,
    OnboardingEditableSummaryAllocationRouting,
    SharedComponentModule,
    WebappComponentModule,
    InfrastructureModule,
    DomainModule,
    IonicModule
  ],
  exports: [],
  declarations: [
    OnboardingEditableSummaryAllocationPage,
    OnboardingAllocationDetailsPage
  ]
})
export class OnboardingEditableSummaryAllocationModule {
}
